// ─────────────────────────────────────────────────────────────
// Firebase configuration
// Get these values from: Firebase Console → Project Settings → Your apps
// ─────────────────────────────────────────────────────────────
export const firebaseConfig = {
  apiKey: 'AIzaSyAvCpzv0I6UTKVSkjYhrc1MjYXABTnYFoQ',
  authDomain: 'propdesk360.firebaseapp.com',
  projectId: 'propdesk360',
  storageBucket: 'propdesk360.firebasestorage.app',
  messagingSenderId: '1044559495201',
  appId: '1:1044559495201:web:c1c6b32c3288c94e37e360',
  measurementId: 'G-RCNFT3ELPL',
};
